import Component from '@glimmer/component';

import { Input } from '@ember/component';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { storageFor } from 'ember-local-storage';

import CIcon from 'rise-ui/components/c-icon.gjs';
import classMod from 'rise-ui/helpers/class-mod.js';
import fnx from 'rise-ui/helpers/fnx.js';
import not from 'rise-ui/helpers/not.js';
import set from 'rise-ui/helpers/set.js';

export default class DebugMenuComponent extends Component {
  @service('debug/debug-menu') service;
  @storageFor('debug') config;

  <template>
    <div class="c-debug-menu">
      <CIcon role="button"
        @icon="debug"
        @text="Toggle Debug"
        @modifier="dark {{unless this.config.enabled "disabled"}}"
        class={{classMod "c-debug-menu__toggle" (not this.config.enabled) "--disabled"}}
        {{on "click" (set this.config "open" (not this.config.open))}}
      />
      <div class="c-debug-menu__body {{unless this.config.open "c-debug-menu__body--closed"}}">
        <div class="c-debug-menu__actions">
          <CIcon role="button"
            @icon="refresh"
            @text="Refresh Route"
            class="c-debug-menu__action c-debug-menu__refresh"
            {{on "click" (fnx @onRefresh)}}
          />
          <CIcon role="button"
            @icon="exit"
            @text="Exit Debug"
            class="c-debug-menu__action c-debug-menu__exit"
            {{on "click" (fnx @onExit)}}
          />
        </div>
        <h3 role="button"
            class="c-debug-menu__title"
          title="Toggle Debug"
          {{on "click" (set this.config "open" (not this.config.open))}}
        >Debug</h3>

        <div class="c-debug-menu__section">
          <label class="c-input c-input__label--post">
            <Input
              @type="checkbox"
              class="c-input__control c-input__control--check"
              @checked={{this.config.enabled}}
            />
            <span class="c-input__label">Enabled Debug</span>
          </label>
        </div>

        {{#each this.service.components as | Component |}}
          <Component />
        {{/each}}

        {{~#if (has-block)}}<div class="c-debug-menu__section">{{yield}}</div>{{~/if~}}
      </div>
    </div>
  </template>
}
